<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: 
    http://cdn.upbicentenario.edu.mx/api/alumnos_reporte
========================================================================================== -->
<template>
  <vx-card title="Estadisticas" code-toggler>
<p style="margin: 10px;">
    <vs-button style="width: 500px;" v-show="id_rol==1 || this.id_rol == 5" class=""  @click="reporte_total()">Reporte de Alumnos Total</vs-button>
</p>
    <p style="margin: 10px;">
    <vs-button style="width: 500px;"  v-show="id_rol==1 || this.id_rol == 5"  class=""  @click="reporte_cuatrimestre()">Reporte de alumnos al Cuatrimestre Actual</vs-button>
    </p>
    <p style="margin: 10px;">
    <vs-button style="width: 500px;"  v-show="id_rol==1 || this.id_rol == 5"  class=""  @click="reporte_egresados()">Reporte de Alumnos que terminaron 64 materias (Posible Egreso)</vs-button>
    </p>
    <p style="margin: 10px;">
    <vs-button style="width: 500px;"  v-show="id_rol==1 || this.id_rol == 5"  class=""  @click="estancias_reporte()">Reporte de Alumnos en Estancias y Estadía del Cuatrimestre Actual</vs-button>
    </p>
    <p style="margin: 10px;">
    <vs-button style="width: 500px;"  v-show="id_rol==1 || this.id_rol == 5"  class=""  @click="cargas_reporte()">Reporte de Cargas de Materias de Matrícula Escolar del Cuatrimestre Actual</vs-button>
    </p>

  </vx-card>
</template>



<script>
import vSelect from 'vue-select'
export default {
  data() {
    return {
       id_rol: this.getKey('id_rol'),
      cuatrimestre_actual: [{ nombre: "", idAgno: "" }],
       token:localStorage.getItem('app-token')

    }
  },
  components: {
    'v-select': vSelect,
    
  },
  created() {
    if(this.id_rol == 1 || this.id_rol == 5){
      //  if(this.id_rol == 1){
          this.$vs.loading();
          this.getCuatrimestreActual();
               
       }
  },
  mounted(){

  },
  watch: {
    // whenever question changes, this function will run

  },
  methods: {
    

    reporte_total(){
       
     window.open('https://cdn.upbicentenario.edu.mx/api/alumnos_reporte/'+this.token);
    },

    reporte_cuatrimestre(){
      window.open('https://cdn.upbicentenario.edu.mx/api/cuatrimestre_reporte/'+this.token);
    },
    estancias_reporte(){
      window.open('https://cdn.upbicentenario.edu.mx/api/estancias_reporte/'+this.token);
    },
    reporte_egresados(){
      window.open('https://cdn.upbicentenario.edu.mx/api/egresados_reporte/'+this.token);
    },
    cargas_reporte(){
      window.open('https://cdn.upbicentenario.edu.mx/api/cargas_reporte/'+this.token);
    },

    
    getCuatrimestreActual(){
      this.$http.get("cuatrimestre_actual").then(
          response => {
    
            this.cuatrimestre_actual = response.data.cuatrimestre_actual;
    
            this.$vs.loading.close();
          },
          error => {
            this.StepError(error);
          }
      );
    },

  },
}
</script>